/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：758
 */

var r = require(/* 714 */"../1648/714")
var o = require(/* 194 */"../1648/194")
module.exports = "process" == r(o.process)
